
// export const logout = ( state ) => {
// }

export const setLocations = (state, locations) => {
    state.locations = locations
}

export const setLocationsSelectable = (state, locations) => {
    state.locationsSelectable = locations
}

export const setLocationsPaginated = (state, locationsPaginatedData) => {
    state.locationsPaginatedData = locationsPaginatedData
}

export const setLocationDetail = (state, location) => {
    state.location = location
}

export const saveNewLocations = (state, location) => {
    state.locations.unshift(location)
    state.createdDataLocation = location;
}

export const saveUpdatedLocation = (state, location) => {
    state.locations.unshift(location)
    state.updatedDataLocation = location;
}

export const setDeleteLocation = (state, location) => {
    state.deletedDataLocation = location
}

export const setLocationIsLoading = (state, isLoadingLocation) => {
    state.isLoadingLocation = isLoadingLocation
}

export const setLocationIsCreating = (state, isCreatingLocation) => {
    state.isCreatingLocation = isCreatingLocation
}

export const setLocationIsUpdating = (state, isUpdatingLocation) => {
    state.isUpdatingLocation = isUpdatingLocation
}

export const setLocationIsDeleting = (state, isDeletingLocation) => {
    state.isDeletingLocation = isDeletingLocation
}

export const setLocationProductIsLoading = (state, isLoadingLocationProduct) => {
    state.isLoadingLocationProduct = isLoadingLocationProduct
}


export const setLocationsProduct = (state, locationsProduct) => {
    state.locationsProduct = locationsProduct
}
